<template>
    <svg v-if="iconPath" viewBox="0 0 24 24" :class="customClass">
        <path :d="iconPath" fill="currentColor" />
    </svg>
    <span v-else></span>
</template>

<script>
import * as icons from '@/icons';

export default {
    name: 'MdiIcon',

    props: {
        // Buefy may pass icon as string, array, or object
        icon: {
            type: [String, Array, Object],
            default: ''
        },
        size: {
            type: String,
            default: ''
        },
        customClass: {
            type: String,
            default: ''
        },
        // Additional props that Buefy might pass
        pack: {
            type: String,
            default: 'mdi'
        },
        both: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: ''
        }
    },

    computed: {
        iconName() {
            // Handle different formats Buefy might pass
            if (!this.icon) return '';

            // Buefy passes icon as array: ['mdi', 'mdi-chevron-down']
            if (Array.isArray(this.icon)) {
                // Get the second element and remove 'mdi-' prefix
                const iconClass = this.icon[1] || '';
                return iconClass.replace(/^mdi-/, '');
            }

            // Direct string usage: 'chevron-down'
            if (typeof this.icon === 'string') return this.icon;

            // Object format: { icon: 'chevron-down' }
            if (typeof this.icon === 'object' && this.icon.icon) return this.icon.icon;

            return '';
        },

        iconPath() {
            if (!this.iconName) return '';

            // Convert kebab-case to PascalCase with 'mdi' prefix
            // e.g., "chevron-down" -> "mdiChevronDown"
            const name =
                'mdi' +
                this.iconName
                    .split('-')
                    .map(s => s.charAt(0).toUpperCase() + s.slice(1))
                    .join('');

            const path = icons[name];

            if (!path && path !== '') {
                console.warn(`[MdiIcon] Icon "${this.iconName}" not found. Add it to icons.js`);
                return '';
            }

            return path;
        }
    }
};
</script>

<style scoped>
svg {
    vertical-align: middle;
    fill: currentColor;
}
</style>
